<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            入库单
        </div>
        <div style="padding: 20px;">

            <div>
                <el-row style="float: left;">
                    <el-button type="primary" :disabled="disabledAdd" @click.native="showForm">物品添加</el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                        :data="waresInfo"
                        :height="th"
                        style="width: 100%" v-loading="tableLoading">
                        <el-table-column prop="name" label="物品名称"></el-table-column>

                        <el-table-column prop="supplierName" label="供应商"></el-table-column>

                        <el-table-column prop="waresTypeName" label="物品类型"></el-table-column>

                        <el-table-column prop="count" label="入库数量"></el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click.native.prevent="editRow(scope.$index, waresInfo)">修改数量</el-button>
                                <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index,waresInfo)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div class="footer" style="display: flex;justify-content: center;padding-top: 15px ;">
                <el-button :loading="loading" type="primary" style="height: 45px;width: 135px;font-size: 16px;" @click="confirm()">提交</el-button>
            </div>
        </div>

        <SelectWares ref="mySelectWares" v-show="showModalSelectWares" v-on:closeSelectWares="closeSelectWares" v-on:getWares='getWares'></SelectWares>

    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,setTokenBykey,removeTokenBykey,getTokenBykey,getMenuButton} from "@/utils/auth";
    import SelectWares from "./SelectWares";

    export default {
        name: "Page",
        data(){
            return{
                tableLoading:true,
                loading:false,
                disabledAdd:true,
                menuButtonList:null,
                showModalAdd:false,
                showModalEdit:false,
                showModalSelectWares:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                waresInfo:[],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    remarks:"",
                    waresArr:null
                },

            }
        },
        components:{
            SelectWares
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight-20;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="物品添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            editRow(index,rows){
                this.$prompt('请输入此物品入库数量', '商品数量', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:/^[1-9]\d*$/,
                    inputErrorMessage:'添加数量不能为零',
                    inputType:'number'
                }).then(({ value }) => {
                    rows[index].count=value
                    this.waresInfo=rows
                    setTokenBykey(getStaffCode()+'waresInfoAdd',this.waresInfo)
                    this.getList()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            },
            closeSelectWares:function(){
                this.showModalSelectWares = !this.showModalSelectWares;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            deleteRow(index, rows){
                rows.splice(index, 1);
                setTokenBykey(getStaffCode()+'waresInfoAdd',this.waresInfo)
            },
            showForm(){
                var list=this.waresInfo
                this.$refs.mySelectWares.init(list);
                this.closeSelectWares()
            },
            getWares(row){
                this.waresInfo.push(row)
                setTokenBykey(getStaffCode()+'waresInfoAdd',this.waresInfo)
            },
            confirm(){
                if(this.waresInfo.length>0){
                    this.$prompt('请输入入库备注', '备注', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputType:'textarea'
                    }).then(({ value }) => {
                        this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                        this.addForm.remarks=value;
                        this.addForm.waresArr=this.waresInfo;
                        this.$axios({
                            method: 'post',
                            url: this.$institutionUrl+"Stockin/Add",
                            data: this.addForm
                        }).then(
                            (response) => {
                                this.loading = false;
                                if (response.data.error == 0) {
                                    removeTokenBykey(getStaffCode()+'waresInfoAdd')
                                    this.getList()
                                }else if(response.data.error == 1){
                                    this.$message({type: 'info', message: response.data.message});
                                }
                            }
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消输入'
                        });       
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '请选择入库物品'
                    });
                }
            },
            getList(){
                this.tableLoading=true;
                var info=getTokenBykey(getStaffCode()+'waresInfoAdd');
                this.tableLoading=false;
                if(info){
                    this.waresInfo=JSON.parse(info)
                }else{
                    this.waresInfo=[]
                }
            },
        }
    }
</script>

<style scoped>

</style>